const CustomModal = ({
  isOpen,
  onClose,
  title,
  onSubmit,
  showButton,
  showSubmitButton = true,
  showCancelButton = true,
  fontSize = "16px",
  fontWeight = "400",
  children,
  modalSize = "",
  minHeight = "200px",
  maxHeight = "550px",
}) => {
  if (!isOpen) return null;
  return (
    <form onSubmit={onSubmit} className="fs-13px">
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      >
        <div className={"modal-dialog " + modalSize}>
          <div
            className="modal-content"
            style={{
              borderRadius: "20px",
              minHeight: minHeight,
              maxHeight: maxHeight,
            }}
          >
            <div
              className="modal-header"
              style={{ border: "none", paddingBottom: "0px" }}
            >
              <h5
                className="modal-title"
                style={{ fontSize: fontSize, fontWeight: fontWeight }}
              >
                {title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div
              className="modal-body"
              style={{
                overflowY: "auto",
                maxHeight: `calc(${maxHeight} - 100px)`,
              }}
            >
              {children}
            </div>

            {showButton && (
              <div className="modal-footer" style={{ border: "none" }}>
                {showCancelButton && (
                  <button
                    onClick={onClose}
                    type="button"
                    className="btn"
                    style={{ ...buttonStyles.base, ...buttonStyles.cancel }}
                  >
                    Cancel
                  </button>
                )}

                {showSubmitButton && (
                  <button
                    onClick={onSubmit}
                    type="button"
                    className="btn"
                    style={{ ...buttonStyles.base }}
                  >
                    Save
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

const buttonStyles = {
  base: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "600",
    minWidth: "107px",
    width: "auto",
    borderRadius: "10px",
    minHeight: "44px",
    height: "auto",
    padding: "10px 20px",
    border: "none",
    outline: "none",
    fontSize: "14px",
    lineHeight: "1.4",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: "#41848F",
    color: "white",
  },
  cancel: {
    backgroundColor: "#C4C4C4",
    color: "#000",
  },
};

export default CustomModal;
